var map = {
	"./page000_game0/config.js": "1bfc",
	"./page000_game1/config.js": "60a7",
	"./page000_game2/config.js": "246d",
	"./page001_game0/config.js": "b64d",
	"./page001_game1/config.js": "d4f7",
	"./page002_game0/config.js": "6273",
	"./page002_game1/config.js": "8d25",
	"./page003_game1/config.js": "583e",
	"./page003_game2/config.js": "bb8e",
	"./page003_game3/config.js": "46a3",
	"./page004_game0/config.js": "c073",
	"./page004_game1/config.js": "5d46",
	"./page005_game1/config.js": "7c90",
	"./page005_game2/config.js": "6f79",
	"./page005_game3/config.js": "c55f",
	"./page005_game4/config.js": "3bc3",
	"./page005_game5/config.js": "3872",
	"./page006_game0/config.js": "aacc",
	"./page006_game1/config.js": "f85d",
	"./page007_game0/config.js": "d701",
	"./page008_game1/config.js": "82aa",
	"./page008_game2/config.js": "8ea1",
	"./page008_game3/config.js": "748a",
	"./page008_game4/config.js": "1933",
	"./page009_game0/config.js": "787f",
	"./page010_game0/config.js": "c192"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd88";